/* eslint-disable */
import { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Chip, Tooltip, IconButton } from '@mui/material';
import { useHistory } from 'react-router';
import styles from './MyMachinesPage.module.scss';
// import ListTable from '../../../../Components/ListTable/ListTable';
import { BackdropLoader } from '../../../Components/Loaders';
import ListTable from '../../../Components/ListTable/ListTable';
import ImageModal from '../../../Components/Modals/ImageModal/ImageModal';
import myMachineService from '../../../Services/AssetServices/myMachine.service';
// import { ListModal } from '../../../Components/Modals';
import { modalActions } from '../../../Actions';
import { notificationServices } from '../../../Services';
import ImagesFinder from '../../../Components/ImagesFinder/ImagesFinder';
import { useAuth } from '@/Components/Auth/Login/auth';
import authActions from '@/Actions/auth.actions';
import drawerActions from '@/Actions/drawer.actions';
import { Filter, ScrollText } from 'lucide-react';
import { filtersInfoChip, handleExportData } from '@/Helpers';
import MachineHealthLogsModal from './MachineHealthLogsModal';

const TABLE_COLUMNS = [
	{
		title: 'Machine Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Mac address',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Store Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Default Process',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Mapped Process',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Current Version',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Last Sync At',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Last updated',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Last updated by',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Health',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Logs',
		config: {
			type: 'DATA',
		},
	},
];

const SPECIAL_COLUMNS = [
	{
		title: 'Edit',
		config: {
			type: 'DATA',
		},
	},
];

const COLMAP = {
	'Machine Name': 'machine_name',
	'Mac address': 'mac',
	'Store Name': 'storeName',
	'Mapped Process': 'processNames',
	'Default Process': 'processName',
	'Current Version': 'currentVersion',
	'Last Sync At': 'lastSyncAt',
	'Last updated': 'updatedAt',
	'Last updated by': 'updated_by',
};

function MyMachinesPage({ createPath, navState, userList, fetchUserList, toggleFiltersDrawer }) {
	const history = useHistory();
	const [isloading, setIsloading] = useState(false);
	const [machinesData, setMachinesData] = useState([]);
	const [latestVersion, setLatestVersion] = useState(false);
	const [selectedStore, setSelectedStore] = useState(null);
	const [filters, setFilters] = useState({});
	const [logsMachine, setLogsMachine] = useState(null);
	const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};

	useEffect(() => {
		if (!SPECIAL_COLUMNS.some((col) => col?.title === 'Update')) {
			SPECIAL_COLUMNS.push({
				title: 'Update',
				config: {
					type: 'DATA',
				},
			});
		}
	}, []);

	const handleListFetch = useCallback(
		({ store = null }) => {
			(async () => {
				setIsloading(true);
				setFilters({
					store: store,
				});
				try {
					const responseData =
						await myMachineService.fetchListOfMachines({
							req: {
								data: {
									storeId: store?.id,
								},
							},
						});
					if (responseData?.statusCode === 200) {
						setSelectedStore(store);
						const sortedMachines = responseData?.data?.machinesList.sort((a, b) => {
							return b?.id - a?.id;
						});
						setMachinesData(sortedMachines);
						setLatestVersion(responseData?.data?.latestVersion);
					}
				} catch (error) {
					// eslint-disable-next-line no-console
					console.log(error);
				} finally {
					setIsloading(false);
				}
			})();
		},
		[
			myMachineService.fetchListOfMachines,
			setMachinesData,
			setSelectedStore,
			selectedStore,
		]
	);
	const handleUpdate = useCallback(
		(versionName, machineId) => {
			(async () => {
				setIsloading(true);
				try {
					const responseData =
						await myMachineService.updateMachineService({
							req: {
								data: {
									versionName: versionName ?? null,
									machineId,
								},
							},
						});
					if (responseData?.statusCode === 200) {
						handleListFetch({ store: selectedStore });
						notificationServices.generateNotification({
							type: 'success',
							message: responseData?.message,
						});
					} else {
						notificationServices.generateNotification({
							type: 'error',
							message: responseData?.message,
						});
					}
				} catch (error) {
					// eslint-disable-next-line no-console
					console.log(error);
				} finally {
					setIsloading(false);
				}
			})();
		},
		[myMachineService.updateMachineService, handleListFetch]
	);
	// eslint-disable-next-line no-unused-vars

	// useEffect(() => {
	// 	handleListFetch({});
	// }, []);

	const SPECIAL_ITEMS = {
		Health: (value, item) => {
			const health = item?.health;
			if (!health?.hasData) {
				return (
					<span style={{ color: '#9ca3af' }}>—</span>
				);
			}
			if (health?.needsAttention) {
				return (
					<Tooltip
						arrow
						title={(
							<div>
								{health?.reasons?.map((reason) => {
									return <div key={reason}>• {reason}</div>;
								})}
							</div>
						)}
					>
						<Chip
							label='Needs Attention'
							color='error'
							size='small'
						/>
					</Tooltip>
				);
			}
			return (
				<Chip
					label='Healthy'
					color='success'
					size='small'
				/>
			);
		},
		Logs: (value, item) => {
			return (
				<Tooltip arrow title='View health logs'>
					<IconButton
						size='small'
						onClick={() => {
							return setLogsMachine(item);
						}}
					>
						<ScrollText className='size-4' />
					</IconButton>
				</Tooltip>
			);
		},
		Edit: (id) => {
			// eslint-disable-next-line no-unused-vars
			const thisItem = machinesData?.find((ele) => {
				return ele.id === id;
			});
			return (
				<Button
					onClick={() => {
						// eslint-disable-next-line prefer-template
						history?.push(createPath + '?isEdit=true&machineId=' + id);
					}}
					variant='outlined'
				>Edit
				</Button>
			);
		},
		Update: (id) => {
			// eslint-disable-next-line no-unused-vars
			const thisItem = machinesData.find((ele) => {
				return ele.id === id;
			});
			return (
				<div
					style={{
						// width: '5rem',
						display: 'flex',
						flexDirection: 'column',
						cursor: 'pointer',
						alignContent: 'center',
						alignItems: 'center',
						gap: '.2rem',
						justifyContent: 'space-evenly',
						justifyItems: 'center',
					}}
				>
					{!thisItem?.toBeUpdated &&
						latestVersion?.version &&
						latestVersion?.version !== thisItem?.currentVersion ? (
						<Button
							variant='contained'
							color='success'
							size='small'
							style={{
								padding: '0px',
								fontWeight: 'bolder',
								color: 'white',
							}}
							onClick={() => {
								handleUpdate(
									latestVersion?.version,
									thisItem?.id
								);
							}}
						>
							Upgrade to {latestVersion?.version}
						</Button>
					) : (
						<>{!thisItem?.toBeUpdated && <>Already to Latest</>}</>
					)}
					{thisItem?.toBeUpdated && (
						<>
							<span style={{ fontSize: '.7rem' }}>
								Changing to{' '}
							</span>
							<span style={{ fontWeight: 500 }}>
								{' '}
								{thisItem?.toBeUpdated}
							</span>
							<Button
								variant='contained'
								color='error'
								size='small'
								onClick={() => {
									handleUpdate(null, thisItem?.id);
								}}
								style={{
									fontSize: '0.7rem',
									wordBreak: 'keep-all',
									color: 'white',
								}}
							>
								Cancel Change
							</Button>
						</>
					)}
					{thisItem?.previous_version &&
						!thisItem?.toBeUpdated &&
						thisItem?.currentVersion !==
						thisItem?.previous_version && (
							// eslint-disable-next-line react/jsx-indent
							<Button
								variant='contained'
								color='warning'
								size='small'
								onClick={() => {
									handleUpdate(
										thisItem?.previous_version,
										thisItem?.id
									);
								}}
								style={{
									fontSize: '.6rem',
									padding: '0px',
								}}
							>
								Downgrade to {thisItem?.previous_version}
							</Button>
						)}
				</div>
			);
		},
	};

	const handleAddClick = () => {
		history.push(createPath);
	};

	const filtersInfo = {
		header: {
			store: false,
		},
		filteredStore: {
			text: 'Machine mapped to (Store)',
			show: true,
		},
	};

	const exportInfo = {
		showExportBtn: true,
	};

	return (
		<div className={styles.root}>
			{/* <ListModal handleConfirm={iAmClicked} singleSelectable /> */}
			<BackdropLoader showProgress isLoading={isloading} />
			<ImageModal />
			<ImagesFinder
				onSubmit={handleListFetch}
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
			/>
			<div className='flex justify-between m-4 '>
				<span className='font-bold text-[16px]'>My Machines</span>
				<div className='flex gap-2'>
					<Button
						onClick={() => {
							toggleFiltersDrawer(true, {
								exportFrontend: true,
								handleExportFrontend: () => {
									// Flatten each machine's health into a plain string column for the CSV.
									const exportColMap = { ...COLMAP, Health: 'healthSummary' };
									const exportData = machinesData?.map((machine) => {
										const health = machine?.health;
										let healthSummary = 'No Data';
										if (health?.hasData) {
											healthSummary = health?.needsAttention
												? `Needs Attention: ${health?.reasons?.join('; ')}`
												: 'Healthy';
										}
										return {
											...machine,
											healthSummary,
										};
									});
									handleExportData(exportData, exportColMap, 'MyMachines');
								},
							});
						}}
						className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
					>
						<span>Filter</span>
						<Filter className='size-4' />
					</Button>
					{level !== 1 && (
						<Button
							onClick={handleAddClick}
							className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
						>
							+ Add Machine
						</Button>
					)}
				</div>
			</div>
			{filtersInfoChip(filtersInfo, filters)}
			<div className={styles?.version}>
				Latest available version{' : '}
				{latestVersion && <span> {latestVersion?.version} </span>}
			</div>
			<ListTable
				colMap={COLMAP}
				columns={TABLE_COLUMNS}
				data={machinesData}
				actions={level !== 1 ? [...SPECIAL_COLUMNS] : []}
				special={SPECIAL_ITEMS}
				showBtnContainer={false}
			/>
			<MachineHealthLogsModal
				open={!!logsMachine}
				machine={logsMachine}
				onClose={() => {
					return setLogsMachine(null);
				}}
			/>
		</div>
	);
}
const mapStateToProps = (state) => {
	const { userPermissions, navState } = state.navigation;
	return {
		userPermissions,
		navState,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleListModal,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyMachinesPage);
